import { render, staticRenderFns } from "./ReviewItemActionsSection.vue?vue&type=template&id=bf717a30&"
import script from "./ReviewItemActionsSection.vue?vue&type=script&lang=js&"
export * from "./ReviewItemActionsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports